export const generateComment = (commentText: string) => `//${commentText}`;
